import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import LiveBooking from 'v-component/smart/live-booking.vue';
import LiveOngoing from 'v-component/smart/live-ongoing.vue';
import LivePlayback from 'v-component/smart/live-playback.vue';
import LiveEnd from 'v-component/smart/live-end.vue';
import LivePause from 'v-component/smart/live-pause.vue';
import LiveUser from 'v-component/smart/live-user.vue';

import {onMounted, onBeforeUnmount, reactive, markRaw, nextTick} from 'vue';
import TIM from 'tim-js-sdk';

import config from 'site-config';
import {getQueryString, loading, setPageTitle, getUidAndNick} from 'common/util';
import {initShare} from 'common/mshare';
import constant from 'common/constant';
import {createTim} from 'common/tim';
import {getTimSign, getLiveDetail} from 'common/service';
import {TimCustomMessageTypeEnum, LiveStatusEnum, TimGroupTipTypeEnum} from 'common/enum';
import {useTimStore} from 'v-store/module/tim';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const timStore = useTimStore();

const {uid, nick} = getUidAndNick();

const live = reactive({
    info: null,
    component: null
});

const statusMapComp = {
    [LiveStatusEnum.LIVE_STATUS_ONGOING]: markRaw(LiveOngoing), // 直播中
    [LiveStatusEnum.LIVE_STATUS_BOOKING]: markRaw(LiveBooking), // 预约
    [LiveStatusEnum.LIVE_STATUS_PAUSE]: markRaw(LivePause), // 暂停
    [LiveStatusEnum.LIVE_STATUS_END_USER]: markRaw(LiveEnd), // 已结束
    [LiveStatusEnum.LIVE_STATUS_END_MANNER]: markRaw(LiveEnd), // 后台终止
    [LiveStatusEnum.LIVE_STATUS_END_PLAYBACK]: markRaw(LivePlayback) // 回放
};

function renderComponent() {
    if (!live.info) {
        return (live.component = markRaw(LiveEnd));
    }
    let status = live.info.status;
    if (status === LiveStatusEnum.LIVE_STATUS_END_USER && live.info.playback_url) {
        status = LiveStatusEnum.LIVE_STATUS_END_PLAYBACK;
    }
    live.component = statusMapComp[status] || statusMapComp[LiveStatusEnum.LIVE_STATUS_END_USER];
}

function setupMShare(shareConfig) {
    const {mshareTitle, mshareUrl, mshareDesc, mshareImage} = shareConfig;
    initShare({
        title: mshareTitle,
        desc: mshareDesc,
        link: mshareUrl,
        imgUrl: mshareImage
    });
}

async function fetchLiveDetail() {
    const info = await getLiveDetail({
        live_id: getQueryString('live_id')
    });
    if (info) {
        live.info = info;
    }
}

const handleMsgMethods = {
    timReceivedMessage: function timReceivedMessage(evt) {
        // console.warn('接收到了消息===', JSON.stringify(evt.data[0].payload));
        evt.data.forEach(handleMsgMethods.eachCallback);
    },
    eachCallback: msg => {
        // 只处理当前直播群消息
        if (!handleMsgMethods.isCurrentGroupMsg(msg)) {
            return;
        }
        switch (msg.type) {
            case TIM.TYPES.MSG_TEXT:
            case TIM.TYPES.MSG_CUSTOM: {
                // 自定义消息
                handleMsgMethods.customMsg(msg);
                break;
            }
            case TIM.TYPES.MSG_GRP_SYS_NOTICE: {
                // 群系统消息
                break;
            }
            case TIM.TYPES.MSG_GRP_TIP: {
                // 群提示消息
                handleMsgMethods.groupTipMsg(msg);
                break;
            }
            default:
                break;
        }
    },
    /**
     * 自定义消息
     *
     * 推流开始（0）：{'command':0,'data':{'msg':'推流开始!'}}
     *  用户加入直播间（1）：{'command':1,'data':{}}
        推流中断（2）：{'command':2,'data':{'msg':'推流中断!'}}
        主播主动结束直播（3）：{'command':3,'data':{'msg':'直播结束!'}}
        后台终止直播（4）：{'command':4,'data':{'msg':'直播终止!'}}
        普通评论（5）：{'command':5,'data':{ 'msg':'评论内容','username': '测试', 'uid': '103212120'}} }}
        主播主动暂停（6）：{'command':6,'data':{}}
        主播主动恢复（7）：{'command':7,'data':{}}
    *
    */
    customMsg: msg => {
        const text = msg.payload.text || msg.payload.data;
        if (!text) {
            return;
        }
        try {
            const res = JSON.parse(text);
            switch (Number(res.command)) {
                case TimCustomMessageTypeEnum.COMMENT_USER:
                case TimCustomMessageTypeEnum.JOIN_USER: {
                    // 用户评论
                    timStore.addMessage({
                        msgId: msg.ID,
                        command: res.command,
                        ...(res.data || {})
                    });
                    break;
                }
                case TimCustomMessageTypeEnum.PUSH_START: {
                    // 开始推流
                    live.component = statusMapComp[LiveStatusEnum.LIVE_STATUS_ONGOING];
                    break;
                }
                case TimCustomMessageTypeEnum.PUSH_PAUSE: {
                    // 推流中断
                    live.component = statusMapComp[LiveStatusEnum.LIVE_STATUS_PAUSE];
                    break;
                }
                case TimCustomMessageTypeEnum.PUSH_END_USER: {
                    // 用户主动结束直播
                    live.component = statusMapComp[LiveStatusEnum.LIVE_STATUS_END_USER];
                    break;
                }
                case TimCustomMessageTypeEnum.PUSH_END_MANNER: {
                    // 后台终止直播
                    live.component = statusMapComp[LiveStatusEnum.LIVE_STATUS_END_MANNER];
                    break;
                }
                case TimCustomMessageTypeEnum.PUSH_PAUSE_USER: {
                    // 用户主动暂停
                    live.component = statusMapComp[LiveStatusEnum.LIVE_STATUS_PAUSE];
                    break;
                }
                case TimCustomMessageTypeEnum.PUSH_REPLAY_USER: {
                    // 用户主动恢复直播
                    live.component = statusMapComp[LiveStatusEnum.LIVE_STATUS_ONGOING];
                    break;
                }
                default:
                    break;
            }
        } catch (err) {
            console.warn('解析消息出错', err);
        }
    },
    /**
     * 处理群提示消息
     */
    groupTipMsg: msg => {
        const type = msg?.payload?.operationType;
        switch (type) {
            case TimGroupTipTypeEnum.UPDATE_GROUP_PROFILE: {
                // 群资料变更
                const groupInfoList = msg.payload.newGroupProfile?.groupAttributeOption?.groupAttributeList || [];
                if (!groupInfoList) {
                    return;
                }
                timStore.updateGroupInfo(groupInfoList);
                break;
            }
            case TimGroupTipTypeEnum.JOIN_MEMBER: {
                // 用户加入群
                const memberList = msg.payload?.memberList || [];
                const messages = memberList.map(member => {
                    return {
                        msgId: msg.ID,
                        username: member.nick,
                        uid: member.userID,
                        command: TimCustomMessageTypeEnum.JOIN_USER
                    };
                });
                timStore.addMessage(messages);
                break;
            }
        }
    },
    /**
     * 判断是否是当前直播群消息
     */
    isCurrentGroupMsg: msg => {
        return live.info.group_id === msg.to;
    },
    /**
     * 初始化群通知
     */
    initNotification() {
        if (!live.info?.notification) {
            return;
        }
        timStore.addMessage({
            msgId: 'pt-comment-notice',
            msg: live.info.notification
        });
    }
};

let timInstance; // tim实例

async function initTim() {
    const groupID = live.info?.group_id;
    if (!groupID) {
        return;
    }
    const userSig = await getTimSign({uid});
    const {tim} = await createTim({
        userID: uid,
        userSig,
        logLevel: config.DEBUG ? 0 : 1,
        appId: config.TIM.APPID,
        listeners: {
            [TIM.EVENT.MESSAGE_RECEIVED]: handleMsgMethods.timReceivedMessage
        },
        onReady: async timIns => {
            try {
                // 初始化个人信息
                const updateMyProfilePromise = timIns.updateMyProfile({
                    nick,
                    allowType: TIM.TYPES.ALLOW_TYPE_ALLOW_ANY
                });
                // 先将该群所有消息已读上报，然后再加入群聊，防止多余消息获取
                const setMessageReadPromise = timIns.setMessageRead({
                    conversationID: `GROUP${groupID}`
                });
                await Promise.all([updateMyProfilePromise, setMessageReadPromise]);
                // 加入直播群
                await timIns.joinGroup({
                    groupID,
                    type: TIM.TYPES.GRP_AVCHATROOM
                });
                // 初始化群资料、群通知
                await timStore.initTim({tim: timIns, groupID});
            } catch (err) {
                console.warn(err);
            }
        }
    });
    timInstance = tim;
}

onMounted(async () => {
    await fetchLiveDetail();
    renderComponent();
    handleMsgMethods.initNotification();
    initTim();
    setPageTitle(
        live.info?.theme ? `${live.info.theme} - ${constant.PAGE.DEFAULT_TITLE}` : constant.PAGE.DEFAULT_TITLE
    );
    setupMShare(live.info?.shareData || {});
    nextTick(() => loading.clear());
});
onBeforeUnmount(() => {
    if (timInstance) {
        timInstance.destroy();
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["live-wrap", {'live-wrap-play': _unref(live).info && _unref(live).info.status !== _unref(LiveStatusEnum).LIVE_STATUS_BOOKING}])
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(live).component), {
      info: _unref(live).info
    }, null, 8 /* PROPS */, ["info"])),
    (_unref(live).info)
      ? (_openBlock(), _createBlock(LiveUser, {
          key: 0,
          class: _normalizeClass({'live-booking-user': _unref(live).info.status === _unref(LiveStatusEnum).LIVE_STATUS_BOOKING}),
          info: _unref(live).info.live_streamer,
          "show-attention": !_unref(live).info.is_attention && _unref(live).info.tuid !== _unref(uid)
        }, null, 8 /* PROPS */, ["class", "info", "show-attention"]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}
}

})